import React from 'react';
import { useIntl } from 'gatsby-plugin-intl';

import AOA from '../../images/american-optometric-association.png';
import Forbes from '../../images/forbes.png';
import HuffPost from '../../images/huffpost.png';
import { TestimonialsBG } from './styles';

export const Testimonials = () => {
  const { formatMessage } = useIntl();

  return (
    <section className="py-12 md:py-24">
      <h2 className="xl:container mx-auto px-4 sm:px-6 lg:px-8 w-full text-2xl md:text-4xl lg:text-6xl font-heading font-bold mb-8 md:mb-12 lg:mb-16 md:text-center">
        {formatMessage({ id: 'publications.title' })}
      </h2>
      <TestimonialsBG className="w-full flex flex-col items-center p-8 md:px-16 md:py-32 lg:p-16 overflow-scroll">
        <div className="md:w-full xl:container mx-auto px-4 sm:px-6 lg:px-8 flex flex-row items-start lg:items-start pr-8 md:pr-0">
          <div className="w-64 sm:w-84 md:w-1/3 mr-2 md:mr-4 px-4 md:px-8 py-6 md:py-10 bg-white border-8 border-blue-900 flex flex-col items-center">
            <img src={HuffPost} className="h-16 lg:h-24 mb-8" />
            <p className="lg:text-xl mb-4">{formatMessage({ id: 'publications.huffpost' })}</p>
            <p className="text-gray-600">- The HuffPost</p>
          </div>
          <div className="w-64 sm:w-84  md:w-1/3 mx-2 md:mx-4 px-4 md:px-8 py-6 md:py-10 bg-white border-8 border-blue-900 flex flex-col items-center">
            <div className="h-16 lg:h-24 mb-8 flex justify-center items-center">
              <img src={Forbes} className="h-8" />
            </div>
            <p className="lg:text-xl mb-4">{formatMessage({ id: 'publications.forbes' })}</p>
            <p className="text-gray-600">- Forbes Magazine</p>
          </div>
          <div className="w-64 sm:w-84 md:w-1/3 ml-2 md:ml-4 px-4 md:px-8 py-6 md:py-10 bg-white border-8 border-blue-900 flex flex-col items-center">
            <img src={AOA} className="h-16 lg:h-24 mb-8" />
            <p className="lg:text-xl mb-4">{formatMessage({ id: 'publications.aoa' })}</p>
            <p className="text-gray-600">- American Optometric Association</p>
          </div>
        </div>
      </TestimonialsBG>
    </section>
  );
};
